import React from 'react';
import style from './GroupButtonsSkeleton.module.scss';

const GroupButtonsSkeleton = ({ count = 5 }) => (
  <div className="row col-12 flex-nowrap overflowX" style={{ height: '34px' }}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className={style.skeletonPill} />
    ))}
  </div>
);

export default GroupButtonsSkeleton;
